import type { UseQueryResult } from "@tanstack/react-query";

/** Keep notification data private across account and work-order access changes. */
export function qcNotificationQuery<T>(path: readonly string[], userId: string | undefined, recheckWhileMounted = false) {
  return {
    queryKey: [...path, { userId }],
    enabled: Boolean(userId),
    staleTime: 0,
    // Authorization can change while this observer remains mounted and focused.
    refetchInterval: recheckWhileMounted ? 15_000 : false as const,
    refetchIntervalInBackground: recheckWhileMounted,
    queryFn: async ({ signal }: { signal: AbortSignal }): Promise<T> => {
      const response = await fetch(path.join("/"), { credentials: "include", signal });
      if (!response.ok) {
        const message = (await response.text()) || response.statusText;
        throw new Error(`${response.status}: ${message}`);
      }
      return response.json();
    },
  };
}

/** Cached authorization is insufficient while a fresh read is pending or denied. */
export function readableNotificationData<T>(query: Pick<UseQueryResult<T>, "data" | "status" | "fetchStatus">): T | undefined {
  return query.status === "success" && query.fetchStatus === "idle" ? query.data : undefined;
}
